import { client } from 'lib/evi-api-gateway';

const resourceUrl = `${process.env.REACT_APP_API_URL_RESOURCE}/api/user/resource_log`;
const url = `${process.env.REACT_APP_API_URL_USER}/merchant`;

export async function getStaffList(params: any) {
  return client.post({
    url: `${url}/staff/get_list`,
    form: {
      ...params
    }
  });
}

// 权限列表名单
export async function roleGroupAPI(params: any) {
  return client.post({
    url: `${url}/role_group/get_list`,
    form: {
      ...params
    }
  });
}

// 刪除
export async function deleteRoleGroup(params: any) {
  return client.post({
    url: `${url}/role_group/delete`,
    form: {
      ...params
    }
  });
}

// add
export async function addRoleGroup(params: any) {
  return client.post({
    url: `${url}/role_group/add`,
    form: {
      ...params
    }
  });
}

// update
export async function updateRoleGroup(params: any) {
  return client.post({
    url: `${url}/role_group/update_role_item`,
    form: {
      ...params
    }
  });
}

// 获取权限设置数据
export async function getRoleItem(params: any) {
  return client.post({
    url: `${url}/role_group/get_role_item`,
    form: {
      ...params
    }
  });
}

// 获取当前所有权限
export async function getAllRoles(params: any) {
  return client.post({
    url: `${url}/role/get_list`,
    form: {
      ...params
    }
  });
}

export async function updateRoleAPI(params: any) {
  return client.post({
    url: `${url}/staff/update_role_group`,
    form: {
      ...params
    }
  });
}
// 保存权限名称
export async function updateRoleGroupName(params: any) {
  return client.post({
    url: `${url}/role_group/update`,
    form: {
      ...params
    }
  });
}
